(function () {
  try {
    function norm(t) {
      return (t || "").replace(/\s+/g, " ").trim();
    }

    function setHeadingOnly(a) {
      var href = a.getAttribute("href") || a.href || "";
      var title = norm(a.textContent);
      if (!href || !title) return;
      localStorage.setItem("collectionParentURL", href);
      localStorage.setItem("collectionParentTitle", title);
      localStorage.removeItem("collectionURL");
      localStorage.removeItem("collectionPage");
      localStorage.setItem("collectionIsHeading", "1");
      localStorage.setItem("collectionContextTS", String(Date.now()));
    }

    function setChildWithParent(childA, parentTitle, parentURL) {
      var href = childA.getAttribute("href") || childA.href || "";
      var title = norm(childA.textContent);
      if (!href || !title) return;

      localStorage.setItem("collectionURL", href);
      localStorage.setItem("collectionPage", title);

      if (parentTitle)
        localStorage.setItem("collectionParentTitle", parentTitle);
      if (parentURL) localStorage.setItem("collectionParentURL", parentURL);

      localStorage.setItem("collectionIsHeading", "0");
      localStorage.setItem("collectionContextTS", String(Date.now()));
    }

    function isDrawerHeading(a) {
      var wrap = a.closest(".text-with-icon");
      return !!(wrap && wrap.querySelector("button[data-panel]"));
    }

    // Find the nearest back button inside the current panel wrapper
    function findBackButtonInCurrentPanel(a) {
      var wrapper = a.closest(".panel__wrapper");
      if (!wrapper) return null;
      return wrapper.querySelector("li button[data-panel]");
    }

    // Given a drawer and a target panel index (0 = first panel),
    // find an anchor in that panel whose text matches title.
    function findAnchorInPanelByTitle(drawer, panelIdx, title) {
      title = norm(title).toLowerCase();
      var panel = drawer.querySelector(
        ".panel-list__wrapper > .panel:nth-child(" + (panelIdx + 1) + ")"
      );
      if (!panel) return null;
      var anchors = panel.querySelectorAll("a[href]");
      for (var i = 0; i < anchors.length; i++) {
        if (norm(anchors[i].textContent).toLowerCase() === title)
          return anchors[i];
      }
      return null;
    }

    // Desktop: set child + parent from mega menu column header
    function setFromDesktopChild(a) {
      var col = a.closest("li.v-stack");
      var parentA = col ? col.querySelector("a.h5") || null : null;
      var pTitle = parentA ? norm(parentA.textContent) : "";
      var pURL = parentA
        ? parentA.getAttribute("href") || parentA.href || ""
        : "";
      setChildWithParent(a, pTitle, pURL);
    }

    document.addEventListener(
      "click",
      function (e) {
        var a = e.target && e.target.closest && e.target.closest("a[href]");
        if (!a) return;

        var inHeader = !!a.closest("header");
        var inDrawer = !!a.closest("navigation-drawer");
        if (!inHeader && !inDrawer) return;

        // Only track collection-like destinations
        var href = a.getAttribute("href") || "";
        if (!/^\/(?:[a-z]{2}\/)?collections\//i.test(href)) return;

        if (!inDrawer) {
          // DESKTOP
          var isDesktopHeading =
            a.matches(".h5") ||
            (a.closest("li.v-stack") &&
              a === a.closest("li.v-stack").querySelector("a.h5"));
          if (isDesktopHeading) {
            setHeadingOnly(a);
          } else {
            setFromDesktopChild(a);
          }
          return;
        }

        // MOBILE DRAWER
        if (isDrawerHeading(a)) {
          // Tapped a top-level heading row
          setHeadingOnly(a);
          return;
        }

        // Tapped a child inside level-2/3: get parent from the CURRENT panel's back button
        var drawer = a.closest("navigation-drawer");
        var backBtn = findBackButtonInCurrentPanel(a);

        var parentTitle = "";
        var parentURL = "";

        if (backBtn) {
          parentTitle = norm(backBtn.textContent);
          // back button points to the parent panel index (0-based)
          var parentPanelIdx = parseInt(
            backBtn.getAttribute("data-panel") || "0",
            10
          );
          // find the anchor for that parent in the referenced panel
          var parentA = findAnchorInPanelByTitle(
            drawer,
            parentPanelIdx,
            parentTitle
          );
          if (parentA) {
            parentURL = parentA.getAttribute("href") || parentA.href || "";
          }
        } else {
          // Fallback: use the visible second panel's back button (rare)
          var btn = drawer.querySelector(
            '.panel-list__wrapper > .panel:nth-child(2) .panel__wrapper:not([hidden]) li button[data-panel="0"]'
          );
          if (btn) {
            parentTitle = norm(btn.textContent);
            var topA = findAnchorInPanelByTitle(drawer, 0, parentTitle);
            if (topA) parentURL = topA.getAttribute("href") || topA.href || "";
          }
        }

        setChildWithParent(a, parentTitle, parentURL);
      },
      true
    );
  } catch (e) {}
})();
